import MonacoEditor from '@monaco-editor/react';
import type { OnMount } from '@monaco-editor/react';

// Кастомная тема для Monaco
const monacoTheme = {
  base: 'vs' as const,
  inherit: true,
  rules: [
    { token: '', foreground: '222222' },
    { token: 'number', foreground: '2563eb' },
  ],
  colors: {
    'editor.background': '#ffffff',
    'editorLineNumber.foreground': '#2563eb',
    'editorLineNumber.activeForeground': '#2563eb',
    'editorGutter.background': '#ffffff',
    'editor.foreground': '#222222',
    'editor.lineHighlightBackground': '#f3f4f6',
    'editorCursor.foreground': '#2563eb',
    'editorIndentGuide.background': '#e5e7eb',
    'editorIndentGuide.activeBackground': '#cbd5e1',
    'editor.selectionBackground': '#e0e7ff',
    'editorWidget.background': '#ffffff',
    'editorWidget.border': '#e5e7eb',
    'editorSuggestWidget.background': '#ffffff',
    'editorSuggestWidget.border': '#e5e7eb',
    'editorSuggestWidget.selectedBackground': '#e0e7ff',
    'editorError.foreground': '#dc2626',
    'editorWarning.foreground': '#f59e42',
  },
};

const handleMount: OnMount = (editor: any, monaco: any) => {
  monaco.editor.defineTheme('custom-light', monacoTheme);
  editor.updateOptions({
    fontFamily: "Menlo, Monaco, Consolas, 'Courier New', monospace",
    fontSize: 14,
    lineNumbersMinChars: 2,
    minimap: { enabled: false },
    scrollBeyondLastLine: false,
    wordWrap: 'on',
    formatOnPaste: true,
    formatOnType: true,
    automaticLayout: true,
    lineDecorationsWidth: 8,
    lineNumbers: 'on',
    renderLineHighlight: 'line',
    overviewRulerLanes: 0,
    hideCursorInOverviewRuler: true,
    scrollbar: {
      vertical: 'auto',
      horizontal: 'auto',
    },
  });
};

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export default function JsonEditor({ value, onChange }: Props) {
  return (
    <div
      className="border-2 rounded-lg p-[2px] bg-white json-editor-outer"
      style={{ fontSize: 14, overflow: 'hidden', borderColor: '#d1d5db' }}
    >
      <style>{`
        .json-editor-outer {
          border-color: #d1d5db !important;
        }
        .monaco-editor {
          outline: none !important;
        }
        .monaco-editor,
        .monaco-editor .overflow-guard,
        .monaco-editor .monaco-editor-background,
        .monaco-editor .margin,
        .monaco-editor .margin-view-overlays,
        .monaco-editor .monaco-scrollable-element,
        .monaco-editor .lines-content,
        .monaco-editor .inputarea,
        .monaco-editor .view-lines {
          border: none !important;
          border-left: none !important;
          border-bottom: none !important;
          box-shadow: none !important;
          background: transparent !important;
          border-radius: 0.5rem !important;
        }
        .monaco-editor .decorationsOverviewRuler {
          display: none !important;
        }
        .monaco-editor:focus,
        .monaco-editor.focused,
        .monaco-editor .monaco-editor-background:focus,
        .monaco-editor .monaco-editor-background.focused,
        .monaco-editor .inputarea:focus,
        .monaco-editor .inputarea:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: none !important;
        }
      `}</style>
      <MonacoEditor
        height="200px"
        language="json"
        value={value}
        onChange={(v: string | undefined) => onChange(v ?? '')}
        onMount={handleMount}
        theme="custom-light"
        options={{
          fontFamily: "Menlo, Monaco, Consolas, 'Courier New', monospace",
          fontSize: 14,
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          wordWrap: 'on',
          formatOnPaste: true,
          formatOnType: true,
          automaticLayout: true,
          lineNumbers: 'on',
          lineNumbersMinChars: 2,
          renderLineHighlight: 'line',
          overviewRulerLanes: 0,
          hideCursorInOverviewRuler: true,
          scrollbar: {
            vertical: 'auto',
            horizontal: 'auto',
          },
        }}
      />
    </div>
  );
} 